module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header solo"
  }, [_c('h3', [_c('a', {
    attrs: {
      "href": _vm.ctx + '/serviceencontact.html#scrollToMessages'
    }
  }, [_vm._v("Mijn berichten \n\t\t\t\t\t"), (_vm.unread.ongelezen > 0) ? _c('span', {
    staticClass: "newmessages"
  }, [_vm._v(_vm._s(_vm.unread.ongelezen))]) : _vm._e(), _vm._v(" "), (!_vm.pageDataLoaded) ? _c('span', {
    staticClass: "newmessages loader"
  }, [_vm._m(0)]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loaderframe"
  }, [_c('div', {
    staticClass: "preloader loading"
  }, [_c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  }), _vm._v(" "), _c('span', {
    staticClass: "slice"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-372ffd18"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/berichten/bericht-ongelezenknop.vue
// module id = 121
// module chunks = 0